import { IGADataSchema } from 'shared/repositories/coworking/entities/ga_data/GADataSchema';
import { ICustomContextParams } from 'shared/types/ICustomContextParams';

export enum EObjectType {
  COWORKING = 14,
  FLEX_OFFICE = 15,
  FIXED_PLACE = 16,
  FLEX_PLACE = 17,
  CONFERENCE_HALL = 18,
  MEETING_ROOM = 19,
}

interface ICustomUrlParams {
  offerId?: number;
  gaObjectType?: EObjectType;
}

export const getCustomUrl = (
  gaData: IGADataSchema | undefined,
  custom: ICustomContextParams,
  params?: ICustomUrlParams,
) => {
  if (!gaData) {
    return '';
  }

  const { cityId, moId, spec, oblId } = gaData;
  const { coworkingId } = custom;
  const { offerId, gaObjectType = EObjectType.COWORKING } = params || {};

  const isOffer = gaObjectType === EObjectType.FLEX_OFFICE && offerId;

  const dealType = isOffer ? 'rent' : 'CW';

  return (
    `/${dealType}/commercial/mo_id=${moId}/obl_id=${oblId}/city_id=${cityId}` +
    `/object_type=/ga_obj_type=${gaObjectType}/spec=${spec}/${isOffer ? offerId : coworkingId}/` +
    `from_developer=0/repres=0/owner=0/pod_snos=0/nv=0/`
  );
};
